export default "__VITE_ASSET__16969cba__"